import { toast } from 'react-toastify';
import ecommercePlatforms from './ecommercePlatforms';

/**
 * The failures a platform sends back as a code on the redirect. The reason is the
 * stable slug the tracking tools receive, and the message is what the user reads.
 */
export const REDIRECT_ERRORS = {
    '6110': {
        reason: 'onboarding_nuvemshop_store_already_linked',
        message: 'Esta loja Nuvemshop já foi conectada com outra conta de usuário.'
    }
}

// A code that is not mapped yet is tracked as it came, so it is not lost.
export const getRedirectErrorReason = code => REDIRECT_ERRORS[code]?.reason || code;

const REDIRECT_ERROR_KEY = 'redirect_error';

const PLATFORM_AUTH_ERROR_KEY = 'platform_auth_error';

export const storeRedirectError = code => {
    sessionStorage.setItem(REDIRECT_ERROR_KEY, code);
}

export const showPendingRedirectError = () => {
    const code = sessionStorage.getItem(REDIRECT_ERROR_KEY);

    if (!code) {
        return;
    }

    sessionStorage.removeItem(REDIRECT_ERROR_KEY);

    return showRedirectError(code);
}

export const showRedirectError = code => {
    const message = REDIRECT_ERRORS[code]?.message;

    if (message) {
        return toast.error(message);
    }

    return toast.error(
        `Não foi possível conectar a sua loja. Por favor, entre em contato com o nosso suporte. (#${code})`
    );
}

/**
 * The authorization that fails or is cancelled on the platform brings the user back
 * on a full page load, when the panel is still checking his session, so the failure
 * is kept until there is a screen to show it on.
 */
export const storePlatformAuthError = platformId => {
    sessionStorage.setItem(PLATFORM_AUTH_ERROR_KEY, platformId || '');
}

export const showPendingPlatformAuthError = () => {
    const platformId = sessionStorage.getItem(PLATFORM_AUTH_ERROR_KEY);

    if (platformId === null) {
        return;
    }

    sessionStorage.removeItem(PLATFORM_AUTH_ERROR_KEY);

    return showPlatformAuthError(platformId);
}

export const showPlatformAuthError = platformId => {
    const platformName = ecommercePlatforms.getById(platformId)?.name;

    if (!platformName) {
        return toast.error('Não foi possível conectar sua loja. Por favor, tente novamente.');
    }

    return toast.error(
        `Não foi possível conectar sua loja à ${platformName}. Por favor, tente novamente.`
    );
}

export const showApiError = error => {
    if (!error) {
        return toast.error('Não foi possível processar sua requisição.');
    }

    if (error.message) {
        return toast.error(error.message);
    }

    if (Array.isArray(error.messages)) {
        if (error.messages.length === 1)
            return toast.error(error.messages[0]);

        const messages = error.messages.map(m => <li>{m}</li>);
        return toast.error(
            <ul>{messages}</ul>
        );
    }
}